import { EditorView } from '@codemirror/view'
import type { ClientUploadedFileData } from 'uploadthing/types'
import { UPLOAD_ENDPOINT } from '@/frontend/design-system/actions/Attachments/UploadFilesButton'
import { uploadFiles } from '@/frontend/design-system/actions/Attachments/uploadthing'

export const uploadImage = async (
  file: File
): Promise<ClientUploadedFileData<{ result: string }>> => {
  const res = await uploadFiles(UPLOAD_ENDPOINT.ATTACHMENT, { files: [file] })
  if (!res || res.length === 0) throw new Error('Upload failed: no result')
  return res[0]
}

export const getAltFromFileName = (file: File) => file.name.replace(/\.[^/.]+$/, '')

export const createAttachmentFromFile = (
  file: File
): ClientUploadedFileData<{ result: string }> => {
  return {
    key: `local-${Date.now()}-${file.name}`,
    name: file.name,
    url: URL.createObjectURL(file),
    size: file.size,
    type: file.type,
    customId: null,
    serverData: { result: 'local-file' },
    appUrl: URL.createObjectURL(file),
    ufsUrl: URL.createObjectURL(file),
    fileHash: ''
  }
}

export const createPasteHandler = (
  onAddAttachment?: (attachment: ClientUploadedFileData<{ result: string }>) => void
) => {
  return EditorView.domEventHandlers({
    paste: (event, view) => {
      const files = event.clipboardData?.files
      if (!files || files.length === 0) return false

      let handled = false

      for (const file of files) {
        if (file.type.startsWith('image/')) {
          event.preventDefault()
          handled = true

          const placeholder = `[Wgrywanie ${file.name} …]`
          const from = view.state.selection.main.from
          const to = view.state.selection.main.to

          view.dispatch({
            changes: { from, to, insert: placeholder }
          })

          void uploadImage(file).then(uploaded => {
            const snippet = `<img src="${uploaded.url}" alt="${getAltFromFileName(file)}" width="" />`

            const index = view.state.doc.toString().indexOf(placeholder, from)
            if (index !== -1) {
              view.dispatch({
                changes: {
                  from: index,
                  to: index + placeholder.length,
                  insert: snippet
                }
              })
            }
          })
        } else if (onAddAttachment) {
          event.preventDefault()
          handled = true
          const attachment = createAttachmentFromFile(file)
          onAddAttachment(attachment)
        }
      }
      return handled
    }
  })
}

export const createDragDropHandler = (
  onAddAttachment?: (attachment: ClientUploadedFileData<{ result: string }>) => void
) => {
  return EditorView.domEventHandlers({
    dragover: event => {
      event.preventDefault()
      return true
    },
    drop: (event, view) => {
      const files = event.dataTransfer?.files
      if (!files || files.length === 0) return false

      let handled = false

      for (const file of files) {
        if (file.type.startsWith('image/')) {
          event.preventDefault()
          handled = true

          const placeholder = `[Wgrywanie ${file.name} …]`
          const from = view.state.selection.main.from
          const to = view.state.selection.main.to

          view.dispatch({
            changes: { from, to, insert: placeholder }
          })

          void uploadImage(file).then(uploaded => {
            const snippet = `<img src="${uploaded.url}" alt="${getAltFromFileName(file)}" width="" />`

            const index = view.state.doc.toString().indexOf(placeholder, from)
            if (index !== -1) {
              view.dispatch({
                changes: {
                  from: index,
                  to: index + placeholder.length,
                  insert: snippet
                }
              })
            }
          })
        } else if (onAddAttachment) {
          event.preventDefault()
          handled = true
          const attachment = createAttachmentFromFile(file)
          onAddAttachment(attachment)
        }
      }
      return handled
    }
  })
}
